<template lang="pug">
yz-filter-menu(:label="$t('panel.name')" :is-active="isActive" :display-value="displayValue" :disable-apply="!patientName || patientName.trim() === ''" @clear="onClear" @apply="onApply")
  .pa-4
    yz-dropdown.mb-3(v-model="searchType" :items="searchOptions" item-text="label" item-value="id" :placeholder="$t('panel.search_type')" size="lg")
    .d-flex.align-center.gap-2
      yz-icon(size=16) $yzi-corner-down-right
      yz-text-field(v-model="patientName" :placeholder="$t('panel.enter_patient_name')" size="lg" width="100%")
</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      searchType: 'patient_name__contains',
      patientName: '',
      isActive: false,
      displayValue: ''
    }
  },
  computed: {
    searchOptions() {
      return [
        { id: 'patient_name', label: this.$t('panel.is') },
        { id: 'patient_name__ne', label: this.$t('panel.is_not') },
        { id: 'patient_name__contains', label: this.$t('panel.contains') },
        { id: 'patient_name__exclude', label: this.$t('panel.does_not_contain') },
        { id: 'patient_name__startswith', label: this.$t('panel.starts_with') },
        { id: 'patient_name__endswidth', label: this.$t('panel.ends_with') }
      ]
    }
  },
  methods: {
    onClear() {
      this.patientName = ''
      this.searchType = 'patient_name__contains'
      this.isActive = false
      this.displayValue = ''
      this.$emit('update:filter', {})
    },
    onApply() {
      this.isActive = true
      const searchLabel = this.searchOptions.find(o => o.id === this.searchType)?.label || ''
      this.displayValue = `${searchLabel} "${this.patientName}"`

      this.$emit('update:filter', {
        key: this.searchType,
        value: this.patientName.trim()
      })
    },
    reset() {
      this.onClear()
    },
    restoreFromParams(params) {
      // Restore filter state from URL params
      // Find which key exists in params
      const possibleKeys = ['patient_name', 'patient_name__ne', 'patient_name__contains', 'patient_name__exclude', 'patient_name__startswith', 'patient_name__endswidth']
      const foundKey = possibleKeys.find(key => params[key] !== undefined)

      if (foundKey) {
        this.searchType = foundKey
        this.patientName = params[foundKey]
        this.onApply()
      }
    }
  }
}
</script>
